<template>
  <div>
    <TextField
      id="phone"
      v-model="form.phoneNumber"
      v-maska
      mask="(###) ###-####"
      labelName="Mobile Number"
      name="phone"
      type="tel"
      inputmode="tel"
      autocomplete="tel"
      aria-label="Mobile Phone Number"
      :status="formStatuses.phoneNumber"
      :required="true"
      :helperText="helperText(formStatuses.phoneNumber)"
      @blur="validatePhone"
    />
    <HelperText
      customClasses="mb-24 leading-5"
      text="I consent to receive text messages. We won't display your phone number to other members."
      :status="2"
    />
  </div>
</template>

<script lang="ts">
import { vMaska } from 'maska';
import helperStatus from '@/helpers/status';
import TextField from '@/components/textfield/TextField.vue';
import HelperText from '@/components/helper_text/HelperText.vue';

export default {
  name: 'PhoneField',
  components: {
    TextField,
    HelperText,
  },
  directives: { maska: vMaska as any },
  data(): any {
    return {
      form: {
        phoneNumber: '',
      },
      formStatuses: {
        phoneNumber: helperStatus.Neutral,
      },
    };
  },
  computed: {
    formattedPhone(): string {
      const digits = this.form.phoneNumber.replace(/\D+/g, '');
      switch (digits.length) {
        case 12:
          return digits.substring(2);
        case 11:
          return digits.substring(1);
        default:
          return digits;
      }
    },
    phoneIsValid() {
      const phoneRegex = /^(\+0?1\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
      return phoneRegex.test(this.form.phoneNumber);
    },
  },
  watch: {
    'form.phoneNumber': function (newValue) {
      if (newValue) {
        this.onInput();
        if (this.phoneIsValid) {
          this.formStatuses.phoneNumber = helperStatus.Neutral;
        }
      }
    },
  },
  methods: {
    onInput() {
      this.$emit('input', 'phoneNumber', this.formattedPhone);
    },
    validatePhone() {
      if (!this.phoneIsValid) {
        this.formStatuses.phoneNumber = helperStatus.Error;
      }

      return this.phoneIsValid;
    },
    helperText(status: helperStatus) {
      if (status === helperStatus.Error) {
        return 'Enter a valid phone number';
      }
      return 'Ex: (111) 111-1111';
    },
  },
};
</script>
